
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalEducateUsers',

    props: {
        steps: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            currentStep: 1,
        }
    },

    computed: {
        currentStepInfo() {
            return this.steps[this.currentStep - 1]
        },
        isLastVoucherStepReached() {
            const isLastStep = this.currentStep === this.steps.length
            const isVoucherStep = this.currentStepInfo?.isVoucher
            return isLastStep && isVoucherStep
        },
    },

    watch: {
        isLastVoucherStepReached(newValue) {
            if (newValue) {
                EventBus.$emit('lastVoucherStepReached', true)
            }
        },
    },

    methods: {
        closeModal() {
            EventBus.$emit('modal-close')
        },

        nextStep() {
            if (this.currentStep < this.steps.length) {
                this.currentStep++
            } else {
                this.closeModal()
            }
        },

        prevStep() {
            if (this.currentStep > 1) {
                this.currentStep--
            }
        },
    },
}
